import { render, staticRenderFns } from "./setHotKeyModal.html?vue&type=template&id=2d5dc063&"
import script from "./setHotKeyModal.vue?vue&type=script&lang=js&"
export * from "./setHotKeyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports